//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const Organization = createAsyncThunk(
  "Organization",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingOrganization(""));
      const response = await UsePortalApi(
        `Patient/Organization`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        dispatch(
          gettingOrganizationSuccess(response[0].entry)
        );
      } else {
        dispatch(
          gettingOrganizationFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingOrganizationFailed(error));
    }
  }
);
const OrganizationSlice = createSlice({
  name: "Organization",
  initialState: {
    OrganizationData: null,
    isOrganizationLoading: false,
    isOrganizationError: false,
  },
  reducers: {
    gettingOrganization: (state, action) => {
      state.OrganizationData = null;
      state.isOrganizationLoading = true;
      state.isOrganizationError = false;
    },
    gettingOrganizationSuccess: (state, action) => {
      state.OrganizationData = action.payload;
      state.isOrganizationLoading = false;
      state.isOrganizationError = false;
    },
    gettingOrganizationFailed: (state, action) => {
      state.OrganizationData = null;
      state.isOrganizationLoading = false;
      state.isOrganizationError = true;
    },
    gettingOrganizationClear: (state, action) => {
      state.OrganizationData = null;
      state.isOrganizationLoading = false;
      state.isOrganizationError = false;
    },
  },
});
export const {
  gettingOrganization,
  gettingOrganizationSuccess,
  gettingOrganizationFailed,
  gettingOrganizationClear,
} = OrganizationSlice.actions;
export default OrganizationSlice.reducer;
